import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import styles from './Footer.module.css'
import renderPrgImage from '../../../../source/programImg'
import renderImage from '../../../../source/importImg'
import DialogModal from '../../../ReusableComponents/DialogModal/DialogModal'
import { connect } from 'react-redux'
import { generateDeviceDataKey } from '../../../ReusableComponents/ByteTransfer/utils'
import { deviceReadIndex, sensorsData } from '../GraphsensorsPortData'

const Footer = ({
    // datasRef,
    ddd = () => {},
    setDatasRef = () => {},
    stopFuntionRef,
    setIsShowTimeInput,
    time,
    setGraphType,
    isPaPlay,
    setIsPaPlay,
    isSelectInternalAccessories,
    portsData,
    worker,
    deselectSensors,
    isConnected,
    slopeInfo,
    addGraph,
    graphRunInfo,
    selectedRunGraph,
    setSelectedGraphRun,
    addPlotData,
    webSerial,
}) => {
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    let history = useHistory()
    const writeIntervalRef = useRef(null)

    const handelGraphType = (e) => {
        if (isPaPlay) {
            return
        }
        setGraphType(e.target.value)
    }
    const handelTimerDivClick = (e) => {
        if (isPaPlay) {
            return
        }
        setIsShowTimeInput(true)
    }

    //handel stop pa read
    const stopPA = () => {
        try {
            worker.postMessage({
                type: 'write',
                value: 'M8',
            })
            clearInterval(writeIntervalRef.current)
            writeIntervalRef.current = null
            setIsPaPlay(false)
            setDatasRef.current({ type: 'setReduxDatas' })
        } catch (e) {
            console.log('ERROR', e)
        }
    }
    stopFuntionRef.current = stopPA

    //handel back button click goes back
    const handelBack = () => {
        sessionStorage.setItem('slideDirection', true)

        if (isPaPlay && writeIntervalRef.current) {
            stopPA()
        }
        deselectSensors()
        history.push('/graphPorts')
    }

    //PA Bytes generat for PeeCee and Atr
    const setPABytes = () => {
        let sendBytes = []
        if (connectedDevice == 'Toki') {
            sendBytes = Array(10).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[8] = 'E'
            sendBytes[9] = 'R'
        } else if (connectedDevice === 'Moki') {
            sendBytes = Array(21).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[19] = 'E'
            sendBytes[20] = 'R'
        } else if (['Humanoid', 'Hexapod'].includes(connectedDevice)) {
            sendBytes = Array(13).fill('0')
            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[11] = 'E'
            sendBytes[12] = 'R'
        } else if (connectedDevice === 'Roboki') {
            sendBytes = Array(10).fill('0')
            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[8] = 'E'
            sendBytes[9] = 'R'
        } else {
            sendBytes = Array(25).fill('0')

            sendBytes[0] = 'P'
            sendBytes[1] = 'A'
            sendBytes[23] = 'E'
            sendBytes[24] = 'R'
        }
        // let internalAccessories = this.props.concept.internalaccessories
        // let portConnections = this.props.assembly.PortConnections

        portsData.map((portDetails) => {
            portDetails.ports.map((port) => {
                if (!port.isChecked) {
                    return
                }
                const getIndex = (portName) => {
                    switch (portName) {
                        case 'A1':
                            return 2
                        case 'A2':
                            return 3
                        case 'B1':
                            return 4
                        case 'B2':
                            return 5
                        case 'C1':
                            return 6
                        case 'C2':
                            return 7
                        case 'D1':
                            return 8
                        case 'D2':
                            return 9
                        case 'E1':
                            return 10
                        case 'E2':
                            return 11
                        case 'F1':
                            return 12
                        case 'F2':
                            return 13
                        case 'G1':
                            return 14
                        case 'G2':
                            return 15
                    }
                }

                const tokiIndex = (portName) => {
                    switch (portName) {
                        case 'servo_motor1':
                            return 5
                        case 'servo_motor2':
                            return 6
                    }
                }

                let arrIndex = getIndex(port.portName)
                if (
                    connectedDevice == 'Toki' &&
                    ['servo_motor1', 'servo_motor2'].includes(port.portName)
                ) {
                    arrIndex = tokiIndex(port.portName)
                }

                //set the bytes analog or digital
                if (port.isDigital) {
                    sendBytes[arrIndex] = 'A'
                } else {
                    sendBytes[arrIndex] = 'I'
                }
            })
        })

        let PORTDATAKey = generateDeviceDataKey(connectedDevice, deviceVersion)
        if (
            [
                'ACE0',
                'ACE1',
                'ROBOKI1',
                'HUMANOID0',
                'HUMANOID1',
                'HUMANOID2',
                'HEXAPOD1',
                'HEXAPOD2',
                'HEXAPOD3',
            ].includes(PORTDATAKey)
        ) {
            let deviceSensorsData = sensorsData[PORTDATAKey]

            Object.values(deviceSensorsData).map(
                ({ reduxName, PABytesIndex, PAByte }) => {
                    if (isSelectInternalAccessories?.[reduxName]) {
                        sendBytes[PABytesIndex] = PAByte
                    }
                    if (
                        reduxName === 'isColorSensor' &&
                        (isSelectInternalAccessories.isRedLight ||
                            isSelectInternalAccessories.isBlueLight ||
                            isSelectInternalAccessories.isGreenLight)
                    ) {
                        sendBytes[PABytesIndex] = PAByte
                    }
                }
            )
        }

        sendBytes = sendBytes.map((char) => char.charCodeAt(0))

        //     const stringToCharCodeArray = (input) =>
        // [...input].map((char) => char.charCodeAt(0))
        return sendBytes
    }

    //write the pa bytes in device'
    const handelWrite = () => {
        try {
            if (isPaPlay && writeIntervalRef.current) {
                stopPA()
                return
            }

            //reset the data state
            let len = Object.keys(graphRunInfo).length
            let totalTime = graphRunInfo?.[`run${len}`]?.totalTime || 0
            setDatasRef.current({ type: 'reset', totalTime })

            let selectedSensors = []
            let PORTDATAKey = generateDeviceDataKey(
                connectedDevice,
                deviceVersion
            )
            const readIndex = deviceReadIndex[PORTDATAKey]
            //calculate the all selected sensors
            Object.keys(isSelectInternalAccessories).map((key) => {
                if (isSelectInternalAccessories?.[key]) {
                    const sensorEntry = Object.keys(readIndex).find(
                        (key1) => readIndex[key1].reduxName === key
                    )
                    selectedSensors.push(sensorEntry)
                }
            })
            portsData.map((portDetails) => {
                portDetails.ports.map((port) => {
                    if (port.isChecked) {
                        selectedSensors.push(port.portName)
                    }
                })
            })

            let sendBytes = setPABytes()
            let counter =
                time.ms +
                time.s * 1000 +
                time.m * 60 * 1000 +
                time.h * 60 * 60 * 1000

            //add new run graph in redux store
            addGraph({ selectedSensors, interValTime: counter, totalTime })

            worker.postMessage({
                type: 'writeArray',
                value: sendBytes,
            })

            // console.log(counter)
            writeIntervalRef.current = setInterval(() => {
                worker.postMessage({
                    type: 'writeArray',
                    value: sendBytes,
                })
            }, counter)
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    //handel play pause the pa bytes
    const handelPlay = () => {
        if (!webSerial.isConnected) {
            return
        }
        setIsPaPlay(!isPaPlay)

        handelWrite()
    }

    //on change the run type change the drop down
    const handelGraphRunChange = (e) => {
        if (isPaPlay) {
            return
        }

        setSelectedGraphRun(e.target.value)
        // const plotData = graphRunInfo?.[e.target.value]?.plotData || []
        // console.log(plotData)

        // setDatasRef.current({ type: 'set', plotData })
    }

    useEffect(() => {
        if (!isConnected && isPaPlay && writeIntervalRef.current) {
            stopPA()
        }
    }, [isConnected])

    return (
        <div className={styles.footer}>
            {/* Left section (40%) */}
            <div className={styles.leftSection}>
                <img
                    src={renderPrgImage('backBtn')}
                    alt="Back"
                    className={styles.backBtn}
                    onClick={handelBack}
                />
            </div>

            {/* Middle section (50%) */}
            <div className={styles.middleSection}>
                {/* first point selected :(5376546, 35) */}
                <div className={styles.middlePanel}>
                    <p className={styles.slopeMessage}>{slopeInfo.message}</p>
                    <div className={styles.controlPanel}>
                        <select
                            className={`${styles.select} ${
                                isPaPlay ? styles.disableStyle : ''
                            }`}
                            onChange={handelGraphType}
                            disabled={isPaPlay}
                        >
                            <option value="lineGraph">Line Graph</option>
                            <option value="barGraph">Bar Graph</option>
                        </select>

                        {graphRunInfo &&
                        Object.keys(graphRunInfo).length > 0 ? (
                            <select
                                value={selectedRunGraph}
                                className={`${styles.select} ${
                                    isPaPlay ? styles.disableStyle : ''
                                }`}
                                onChange={handelGraphRunChange}
                                disabled={isPaPlay}
                            >
                                {Object.keys(graphRunInfo).map((objKey) => (
                                    <option key={objKey} value={objKey}>
                                        {graphRunInfo[objKey].label}
                                    </option>
                                ))}
                                <option value="selectAll">All Data</option>
                            </select>
                        ) : (
                            <div className={styles.select}>No Data</div>
                        )}

                        <div
                            className={`${styles.timerBox} ${
                                isPaPlay ? styles.disableStyle : ''
                            }`}
                            onClick={handelTimerDivClick}
                        >
                            <span>
                                {time.h}:{time.m}:{time.s}:{time.ms}
                            </span>

                            <img
                                className={styles.TimeEdit}
                                src={renderImage('editBlackIcon')}
                                alt="edit button"
                                onClick={(event) => {}}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/*  Right section (10%) */}
            <div className={styles.rightSection}>
                <div
                    className={styles['playBtnDiv']}
                    style={
                        Object.keys(graphRunInfo)?.length === 0 || isPaPlay
                            ? { top: '10%' }
                            : {}
                    }
                >
                    {graphRunInfo &&
                        Object.keys(graphRunInfo).length > 0 &&
                        !isPaPlay && <p>Calculate slope</p>}
                    {/* <p>Calculate slope</p> */}
                    {/* <div className={styles['playBtn-div']}> */}
                    <img
                        className={styles['playBtn']}
                        src={
                            isPaPlay
                                ? renderPrgImage('pauseBtn')
                                : renderPrgImage('playrunBtn')
                        }
                        onClick={handelPlay}
                        style={
                            !webSerial.isConnected
                                ? {
                                      cursor: 'default',
                                      opacity: '0.5',
                                  }
                                : {}
                        }
                    />
                </div>
                {/* <p
                        className={`${createStyle.tooltip} ${createStyle.groupPlaydbtn}`}
                        style={{
                            position: 'absolute',
                            right: '-11vh',
                            top: '-38%',
                            width: '16vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        play actions group
                    </p> */}
                {/* </div> */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isConnected: state.webSerial.isConnected,
        worker: state.worker,
        time: state.graphPlotStorage.time,
        isSelectInternalAccessories:
            state.graphPlotStorage.isSelectInternalAccessories,
        portsData: state.graphPlotStorage.internalaccessories.portsData,
        slopeInfo: state.graphPlotStorage.slopeInfo,
        graphRunInfo: state.graphPlotStorage.graphRunInfo,
        selectedRunGraph: state.graphPlotStorage.selectedRunGraph,
        webSerial: state.webSerial,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        graphPlotStorage: (data) => {
            dispatch({ type: 'GRAPH_PLOTSTORAGE', payload: data })
        },
        setGraphType: (data) => {
            dispatch({ type: 'SET_GRAPH_TYPE', payload: data })
        },
        DeselectedComponent: (data) => {
            dispatch({ type: 'GRAPH_PLOTSTORAGE', payload: data })
        },
        deselectSensors: (data) => {
            dispatch({ type: 'DESELECT', payload: data })
        },
        addGraph: (data) => {
            dispatch({ type: 'ADD_GRAPH', payload: data })
        },
        setSelectedGraphRun: (data) => {
            dispatch({ type: 'SET_SELECTED_GRAPH_RUN', payload: data })
        },
        addPlotData: (data) => {
            dispatch({ type: 'ADD_PLOT_DATA', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Footer)
